/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ReorderModalLocationRestaurantQueryVariables = Exact<{
  id: string | number;
}>;

export type ReorderModalLocationRestaurantQuery = {
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly name: string;
    readonly isOutpost: boolean;
  } | null;
};

export type ReorderModalLocationAddressQueryVariables = Exact<{
  addressId: string | number;
}>;

export type ReorderModalLocationAddressQuery = {
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly name: string | null;
    readonly street: string;
  } | null;
};

export const ReorderModalLocationRestaurantDocument = gql`
  query ReorderModalLocationRestaurant($id: ID!) {
    restaurant(id: $id) {
      __typename
      id
      name
      isOutpost
    }
  }
`;

export function useReorderModalLocationRestaurantQuery(
  options: Omit<Urql.UseQueryArgs<ReorderModalLocationRestaurantQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    ReorderModalLocationRestaurantQuery,
    ReorderModalLocationRestaurantQueryVariables
  >({ query: ReorderModalLocationRestaurantDocument, ...options });
}
export const ReorderModalLocationAddressDocument = gql`
  query ReorderModalLocationAddress($addressId: ID!) {
    address(addressId: $addressId) {
      __typename
      id
      name
      street
    }
  }
`;

export function useReorderModalLocationAddressQuery(
  options: Omit<Urql.UseQueryArgs<ReorderModalLocationAddressQueryVariables>, 'query'>,
) {
  return Urql.useQuery<ReorderModalLocationAddressQuery, ReorderModalLocationAddressQueryVariables>(
    { query: ReorderModalLocationAddressDocument, ...options },
  );
}
